An opaque cursor to the later bounding event.

Resulting events will _precede_ this cursor.
